import type { CandidateVacancy } from '../types';

type CandidateCurrency = NonNullable<CandidateVacancy['currency']>;

export function mockCandidateCurrency(
  overrides: Partial<CandidateCurrency> = {}
): CandidateCurrency {
  return {
    id: 1,
    code: 'EUR',
    name: 'Euro',
    value: '€',
    ...overrides,
  };
}
